import { useCallback } from 'react';

import { useEligibleServicesModalStore } from '../stores/useEligibleServicesModal.store';

const useEligibleServicesModal = () => {
  const visible = useEligibleServicesModalStore((state) => state.modalVisible);
  const handleChangeVisibility = useEligibleServicesModalStore((state) => state.handleChangeVisibility);

  const handleOpen = useCallback(() => {
    handleChangeVisibility(true);
  }, [handleChangeVisibility]);

  const handleClose = useCallback(() => {
    handleChangeVisibility(false);
  }, [handleChangeVisibility]);

  return { visible, handleOpen, handleClose };
};

export default useEligibleServicesModal;
